import PhotoSwipeLightbox from 'photoswipe/lightbox';

export function initPhotoSwipe() {
    // Vérifie si on est sur la bonne page pour éviter les erreurs
    if (!document.body.classList.contains('single-estate')) return;

    const lightbox = new PhotoSwipeLightbox({
        gallery: '.estate-gallery',
        children: 'a',
        pswpModule: () => import('photoswipe')
    });
    lightbox.init();

    const buttonPictures = document.querySelector('.button-pictures');
    if (buttonPictures) {
        buttonPictures.addEventListener('click', () => {
            lightbox.loadAndOpen(5, {
                gallery: document.querySelector('.estate-gallery')
            });
        });
    }
}
